<template>
  <transition name="fade" mode="out-in">
    <div class="text-danger" v-for="(error, i) in errors" v-bind:key="`errorList_${i}`">{{error}}</div>
  </transition>
</template>

<script>
export default {
  name: "error-panel",
  props: {
    errors: Array
  }
};
</script>
